import { filter } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

import { ChildrenRenderer } from 'hb-builder/components/Renderer/ChildrenRenderer';
import { useComponentsContext } from 'hb-builder/contexts/ComponentsContext';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import { extractAndLoadFonts } from 'hb-builder/utils/fonts';
import { cleanHtml } from 'hb-builder/utils/item';
import { getCustomFontName } from 'hb-react/backoffice/components/PageBuilder/utils/getCustomFontName';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

export const TraverseItem = ({ item }: { item: DocumentItem }) => {
  const [isFontLoaded, setIsFontLoaded] = useState(false);
  const { components } = useComponentsContext();
  const Component = components?.[item?.type];

  const {
    hivebrite: { networkTheming },
  } = useBuilderConfigContext();

  const customFontName = getCustomFontName(networkTheming);

  useEffect(() => {
    if (item && !isFontLoaded) {
      extractAndLoadFonts(item, undefined, customFontName);
      setIsFontLoaded(true);
    }
  }, [item, isFontLoaded]);

  const children = useMemo(() => {
    if (Component) {
      return item?.children && filter(item.children, Boolean)?.length > 0 ? (
        <ChildrenRenderer item={item} />
      ) : (
        cleanHtml(item)
      );
    }

    return null;
  }, [Component, item]);

  if (!Component) {
    return null;
  }

  return (
    <Component.Render key={item.id} item={item}>
      {children}
    </Component.Render>
  );
};
